import JSONPathParser from "./JSONPathParser";

export function newMatchJSON(expression : string, content, extractStrings = true) {
    //console.log("Parsing expression", expression);
    if (expression === null || expression === undefined) {
        return null;
    }

    try {
        return JSONPathParser.parse(expression, {
            content: content,
            extractStrings: extractStrings,
        });
    } catch (e) {
        throw new Error(JSON.stringify({expression: expression, error: e}));
    }
}
